import L from 'leaflet';

const cache = new Map<string, L.DivIcon>();

export function createPinIcon(
  emoji: string,
  commentCount: number,
  isRecent: boolean,
  markerImage?: string,
): L.DivIcon {
  const cacheKey = `${emoji}_${commentCount}_${isRecent}_${markerImage || ''}`;
  const cached = cache.get(cacheKey);
  if (cached) return cached;

  const size = markerImage ? 42 : 36;
  const pulse = isRecent
    ? `<span style="position:absolute;inset:-4px;border-radius:50%;border:2px solid #a78bfa;animation:stabeon-pulse 1.8s ease-out infinite;opacity:.6"></span>`
    : '';

  const badge = commentCount > 0
    ? `<span style="position:absolute;top:-4px;right:-4px;min-width:16px;height:16px;border-radius:8px;background:#7c3aed;color:white;font-size:9px;font-weight:700;display:flex;align-items:center;justify-content:center;padding:0 3px;box-shadow:0 1px 4px rgba(0,0,0,0.4)">${commentCount > 99 ? '99+' : commentCount}</span>`
    : '';

  const hasImage = markerImage && markerImage.length > 20;

  const content = hasImage
    ? `<img src="${markerImage}" style="width:100%;height:100%;object-fit:cover;border-radius:50%" />`
    : emoji;

  const bgStyle = hasImage
    ? 'background:transparent;overflow:hidden;'
    : 'background:rgba(124,58,237,0.15);';

  const html = `
    <div style="position:relative;width:${size}px;height:${size}px;cursor:pointer">
      ${pulse}
      <div style="
        width:${size}px;height:${size}px;
        border-radius:50%;
        ${bgStyle}
        border:2px solid rgba(124,58,237,0.5);
        backdrop-filter:blur(8px);
        display:flex;align-items:center;justify-content:center;
        font-size:18px;
        box-shadow:0 2px 12px rgba(124,58,237,0.3);
        transition:transform 0.15s;
      ">${content}</div>
      ${badge}
    </div>`;

  const icon = L.divIcon({
    html,
    className: '',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -(size / 2 + 6)],
  });

  cache.set(cacheKey, icon);
  return icon;
}
